module.exports = __webpack_public_path__ + "static/img/servebanner.2c4caeb.png";


//////////////////
// WEBPACK FOOTER
// ./public/humanImg/servebanner.png
// module id = 3QAQ
// module chunks = 0